import React from 'react';

// Contenido legal de los Términos y Condiciones para coaches.
// Fuente única de verdad: lo usan tanto la página pública (CoachTerms.jsx)
// como el modal de aceptación obligatoria (CoachTermsGate.jsx).
// Si editas este texto, sube COACH_TERMS_VERSION en el backend para forzar
// que los coaches vuelvan a aceptar.
export default function CoachTermsContent() {
  return (
    <>
      <h1 id="top">Términos y Condiciones — Wayo Coach</h1>
      <p className="last-updated"><strong>Última actualización:</strong> 8 de marzo de 2026</p>

      <p>
        Estos Términos y Condiciones regulan el uso de la plataforma Wayo Coach (la "Plataforma"),
        incluyendo la sección y funcionalidades dirigidas a entrenadores, profesionales y centros ("Coaches")
        y a las personas que contratan sus servicios ("Clientes").
      </p>

      <h2 id="titular-datos">1. Titular y datos de contacto</h2>
      <p>
        Titular: Wayo.
        <br />Contacto: soporte@wayoai.app
      </p>

      <h2 id="aceptacion">2. Aceptación</h2>
      <p>
        El acceso y uso de la Plataforma implica la aceptación íntegra de estos Términos. Si no estás de
        acuerdo, no utilices la Plataforma.
      </p>

      <h2 id="objeto-alcance">3. Objeto y alcance</h2>
      <p>
        Wayo pone a disposición una plataforma tecnológica que facilita la conexión entre Coaches y Clientes.
        Wayo actúa como intermediario técnico; no presta servicios profesionales ni supervisa la relación
        contractual entre Coaches y Clientes.
      </p>

      <h2 id="registro-elegibilidad">4. Registro y elegibilidad</h2>
      <p>
        Para utilizar ciertas funciones es necesario registrarse. Los usuarios garantizan que los datos
        facilitados son veraces y que cuentan con la capacidad legal para contratar. El registro como Coach
        puede requerir información adicional y el cumplimiento de requisitos profesionales aplicables.
      </p>

      <h2 id="servicios-responsabilidad">5. Servicios y responsabilidad</h2>
      <p>
        Los Coaches son responsables de la calidad, legalidad y veracidad de los servicios ofrecidos.
        Wayo no supervisa ni garantiza resultados; cualquier contrato o acuerdo entre Coach y Cliente se
        entiende exclusivamente entre las partes.
      </p>

      <h2 id="pagos-comisiones">6. Pagos y comisiones</h2>
      <p>
        Las transacciones pueden gestionarse a través de pasarelas de pago externas del coach (por ejemplo, Stripe externo, PayPal, Bizum o transferencia).
        Wayo no procesa, retiene ni verifica estos cobros; los detalles comerciales se acuerdan entre
        Coach y Cliente y se muestran en la Plataforma.
      </p>

      <h2 id="contenido-usuarios">7. Contenido de usuarios</h2>
      <p>
        Al subir contenido (textos, imágenes, planes, vídeos), el usuario garantiza derechos sobre el mismo
        y otorga a Wayo una licencia limitada para operar la Plataforma y mejorar los servicios (por ejemplo,
        para entrenar modelos relacionados con la Plataforma) o hacer uso de dicho contenido como publicidad.
      </p>

      <h2 id="proteccion-datos">8. Protección de datos</h2>
      <p>
        El tratamiento de datos personales se rige por la Política de Privacidad de Wayo. Los usuarios deben
        cumplir la normativa aplicable en materia de protección de datos y obtener los consentimientos necesarios
        cuando compartan datos de terceros.
      </p>

      <h2 id="suspension-terminacion">9. Suspensión y terminación</h2>
      <p>
        Wayo podrá suspender o cancelar cuentas por incumplimiento de estos Términos o por razones de seguridad
        o legales. Las decisiones de Wayo podrán adoptarse sin previo aviso cuando existan indicios de uso
        indebido o riesgo para la comunidad.
      </p>

      <h2 id="limitacion-responsabilidad">10. Limitación de responsabilidad</h2>
      <p>
        En la máxima medida permitida por la ley, Wayo no será responsable de daños derivados de la utilización
        de la Plataforma, de las relaciones contractuales entre Coaches y Clientes, ni de la información publicada
        por terceros.
      </p>

      <h2 id="legislacion-jurisdiccion">11. Legislación aplicable y jurisdicción</h2>
      <p>
        Estos términos se rigen por la legislación española. Para consumidores, la jurisdicción aplicable será
        la correspondiente a su lugar de residencia; para usuarios empresariales o profesionales, los tribunales
        de Las Palmas de Gran Canaria (España) serán competentes.
      </p>

      <h2 id="contacto">12. Contacto</h2>
      <p>
        Para consultas o reclamaciones: soporte@wayoai.app
      </p>
    </>
  );
}
